'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visitorThreadCreated = undefined;

var _buildConversation = require('conversations-schema/factories/ConversationFactory/buildConversation');

var _ChatFilterOptions = require('conversations-schema/constants/ChatFilterOptions');

var _ChatFilterOptions2 = _interopRequireDefault(_ChatFilterOptions);

var _ThreadSources = require('conversations-schema/constants/ThreadSources');

var _openConversationForNewChannel = require('../../actions/ConversationsActions/openConversationForNewChannel');

var _setCurrentChannel = require('../../actions/ConversationsActions/setCurrentChannel');

var _resetStubbedThread = require('../../stubbed-thread-history/actions/resetStubbedThread');

var _publishAllMessagesInHistoryToChannel = require('../../thread-histories/actions/publishAllMessagesInHistoryToChannel');

var _getStubbedThreadHistory = require('../../stubbed-thread-history/selectors/getStubbedThreadHistory');

var _initializeVisitorOnlineChannel = require('../../actions/initializeVisitorOnlineChannel');

var _postConversationStartedEvent = require('./postConversationStartedEvent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var visitorThreadCreated = exports.visitorThreadCreated = function visitorThreadCreated(_ref) {
  var channel = _ref.channel,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var conversation = (0, _buildConversation.buildConversation)({
      channel: channel,
      threadId: threadId,
      source: _ThreadSources.LIVE_CHAT,
      status: _ChatFilterOptions2.default.STARTED
    }).set('latestSessionStartedAt', Date.now());

    var promise = dispatch((0, _openConversationForNewChannel.openConversationForNewChannel)({
      channel: channel,
      conversation: conversation,
      shouldNotifyBySound: false
    })).then(function () {
      dispatch((0, _initializeVisitorOnlineChannel.initializeVisitorOnlineChannel)(channel, threadId));
      dispatch((0, _publishAllMessagesInHistoryToChannel.publishAllMessagesInHistoryToChannel)({
        channel: channel,
        threadId: threadId,
        history: (0, _getStubbedThreadHistory.getStubbedThreadHistory)(getState())
      }));

      dispatch((0, _setCurrentChannel.setCurrentChannel)(channel));
      dispatch((0, _resetStubbedThread.resetStubbedThread)());

      dispatch((0, _postConversationStartedEvent.postConversationStartedEvent)({ thread: conversation }));
    });

    promise.done();
    return promise;
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/threads/actions/visitorThreadCreated.js
// module id = 523
// module chunks = 2 3